module.exports = __webpack_public_path__ + "img/advert-bg.214021f9.jpg";